module.exports = function() {
  return new Worker(__webpack_public_path__ + "9f48369d28a2ec7c6d66.worker.js");
};